import { ForcedExperiments, OptimizelyClient } from "../types";

const getForcedExperiments = (
  optimizelyClient: OptimizelyClient,
  queryParams: URLSearchParams,
  isFeatureExperimentation: boolean,
): ForcedExperiments => {
  const config = optimizelyClient.getOptimizelyConfig() ?? {
    featuresMap: {},
    experimentsMap: {},
  };
  const experimentMap = isFeatureExperimentation
    ? config.featuresMap
    : config.experimentsMap;
  const experimentIds = Object.keys(experimentMap);
  const forcedExperiments = experimentIds
    .filter((experimentId) => queryParams.has(experimentId))
    .map((experimentId) => ({
      experimentId,
      variation: queryParams.get(experimentId) ?? "",
    }));

  return forcedExperiments;
};

export default getForcedExperiments;
